import { render, staticRenderFns } from "./zxw-select.vue?vue&type=template&id=27868aa4&"
import script from "./zxw-select.vue?vue&type=script&lang=js&"
export * from "./zxw-select.vue?vue&type=script&lang=js&"
import style0 from "./zxw-select.vue?vue&type=style&index=0&id=27868aa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports